import PreviewScreen from "./MainSwiper"

export default PreviewScreen
